import { render, staticRenderFns } from "./Foot1230.vue?vue&type=template&id=29d20288"
import script from "./Foot1230.vue?vue&type=script&lang=js"
export * from "./Foot1230.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports